import { COMPANY_TYPES } from "shared/types/enums";

import { AllCompanyType, RootCompanyTypeOption } from "./types/types";

export const ROOT_FILTER = "rootFilter";
export const ALL_COMPANY_TYPES: AllCompanyType = "All";

export const ALL_COMPANY_TYPE_OPTIONS: RootCompanyTypeOption[] = [
    ALL_COMPANY_TYPES,
    ...Object.values(COMPANY_TYPES)
];
